// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer-examination-test-back[data-v-bcf8ae32]{letter-spacing:1px}.answer-examination-test-back .student-answer-information[data-v-bcf8ae32]{background-color:#fff;min-height:40rem;border-radius:10px;padding:3rem 2rem;position:relative}.student-score-information[data-v-bcf8ae32]{margin:1rem 0}.student-score-information[data-v-bcf8ae32],.student-test-information[data-v-bcf8ae32]{background-color:#fff;min-height:40rem;border-radius:10px;padding:3rem 2rem}", ""]);
// Exports
module.exports = exports;
